(function() {
	"use strict";

	angular.module( "ATMGurus" )

	.controller( "TrainingController", [
		"classesBookingService",
		"$state",
		"User",
		"FormService",
		"$scope",
		"$rootScope",
		function( bookingService, $state, User, FormService, $scope, $rootScope ) {


			this.user = User.getUserData();
			this.bookedClasses = bookingService.bookedClasses;

			this.isLoading = function() {
				return bookingService.loading()
			}

			/**
			*
			*	pre-populate the form
			*
			*/
			if ( angular.isDefined( this.user.billingAddress ) ) {
				this.formData = {
					name: User.getFullName(),
					brands_serviced: {
						triton: false,
						nautilus: false,
						tidel: false,
						tranax: false,
						ncr: false,
						diebold: false,
						wincor: false,
						wrg: false,
						greenlink: false,
						nurit: false,
						rhino: false,
						grg: false,
						other: false
					},
					country: ( this.user.billingAddress.country ) || "US",
					state: this.user.billingAddress.state || "",
					customer_name: this.user.billingAddress.customer_name,
					address_line1: this.user.billingAddress.address1,
					address_line2: this.user.billingAddress.address2,
					address_line3: this.user.billingAddress.address3,
					address_line4: this.user.billingAddress.address4,
					postal_code: this.user.billingAddress.postal_code,
					city: this.user.billingAddress.city,
					email: this.user.userDetails.email,
					mobile_phone: this.user.userDetails.phone
				}
			}

			this.countries = require('../../assets/lib/countries.json')

			/**
			*	send user to registration form
			*/
			this.checkoutClasses = function() {
				$state.go( "schedule.registration" );
			}


			/**
			*/
			this.gotClasses = function() {
				return _.isEmpty( bookingService.getBookedClasses() );
			}

			/**
			*	form submission
			*/
			this.submit = function() {

				this.formData.classes = bookingService.getBookedClasses();

				$scope.$emit( "modal.open", {} )
				FormService.post("web-forms/training-registration", this.formData)
					.then( function( response ) {
						$scope.$emit( "modal.close", {} )
						$scope.$emit( "modal.open", { title: "Registration confirmed", template: 'success', data: { message: response.message} } )
						bookingService.resetBookedClasses()
					})

			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/controllers/TrainingController.js